import { useBreakpoint } from '@resi-media/resi-ui';

export function useTileColumnCount({ def, lg, md, sm, xl, xs }: { [key: string]: number | undefined } = {}) {
  const { lg: lgBp, md: mdBp, sm: smBp, xl: xlBp, xs: xsBp } = useBreakpoint();

  if (xlBp) {
    return xl ?? 5;
  }
  if (lgBp) {
    return lg ?? 4;
  }
  if (mdBp) {
    return md ?? 2;
  }
  if (smBp) {
    return sm ?? 2;
  }
  if (xsBp) {
    return xs ?? 2;
  }
  return def ?? 2;
}
